<script setup>
import { computed } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";

const { logout, user, isAuthenticated } = useAuth0();
const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};

const isAdmin = computed(() => {
  const roles = user.value?.['https://blything.co.uk/roles'] || [];
  return roles.includes('Admin');
});
</script>

<template>
  <div class="grid-x full-width">
    <div class="cell small-12 medium-offset-1 medium-10 large-offset-1 large-10 white-section content-section">
      <div class="grid-x">
        <div class="cell small-12 medium-12 large-12">
          <div class="main-content">

            <div v-if="isAuthenticated">
              <h2 class="left-align">Admin user: {{ user?.meta_firstname }} {{ user?.meta_lastname }}</h2>

              <!-- Display admin-specific UI -->
              <div v-if="isAdmin" class="admin-badge">
                <p><font-awesome-icon :icon="['fas', 'shield-halved']" /> Admin Dashboard Access <span class="tick"><font-awesome-icon :icon="['fas', 'circle-check']" /></span></p>
              </div>
            </div>


            <h1 class="center-text">Admin Control Centre</h1>
            <p>
              To be completed.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "../assets/styles/admin.scss";
</style>
